import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";

class PrenatalVisitInitials {
    public Value: string;
    public UserContactFacetIds: string[];
    public OriginalMapping: { [key: string]: string; };

    constructor(fields?: Partial<PrenatalVisitInitials>) {
        this.Value = "";
        this.UserContactFacetIds = [];
        this.OriginalMapping = {};

        Object.assign(this, fields);
    }

    public addInitialsFromUser(user: EmployeeUIModel, existingInitials: PrenatalVisitInitials[], separator: string): string {
        if (!this.tryAddUserContactFacetId(user.ContactFacetId))
            return null;

        if (this.Value)
            this.Value += separator;

        const initials = this.extractInitials(user, existingInitials, separator);
        this.Value += initials;

        return initials;
    }

    public tryAddUserContactFacetId(contactFacetId: string): boolean {
        if (this.UserContactFacetIds.any(id => id === contactFacetId))
            return false;

        this.UserContactFacetIds.push(contactFacetId);
        return true;
    }

    private extractInitials(user: EmployeeUIModel, existingInitials: PrenatalVisitInitials[], separator: string): string {
        const firstName = user.Model?.FirstName ?? "";
        const lastName = user.Model?.LastName ?? "";

        const firstInitial = firstName ? firstName[0].toUpperCase() : "";
        const lastInitial = lastName ? lastName[0].toUpperCase() : "";

        for (let initials of existingInitials) {
            if (initials.OriginalMapping[user.ContactFacetId])
                return initials.OriginalMapping[user.ContactFacetId];
        }

        this.OriginalMapping[user.ContactFacetId] = this.appendLettersToInitals(firstInitial + lastInitial, lastName, existingInitials, separator);

        return this.OriginalMapping[user.ContactFacetId];
    }

    private appendLettersToInitals(initials: string, lastName: string, existingInitials: PrenatalVisitInitials[], separator: string): string {
        if (!this.Value || !initials)
            return initials;

        const splitExistingInitials = existingInitials.map(i => i.Value).join(separator).split(separator);

        let i = 1;
        while (splitExistingInitials.some(i => i.toUpperCase() === initials.toUpperCase()) && i < lastName.length) {
            initials += lastName[i++];
        }

        return initials;
    }
}

export { PrenatalVisitInitials };
